import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Result } from "antd"

import { isEqual, omit } from "lodash"
import { useTitle } from "hooks/useTitle"
import useSearchFilter from "hooks/useSearchFilter"
import moment from "moment"

import { useDispatch, useSelector } from "react-redux"
import { getDashboardData } from "store/dashboard"
import { guideForecast } from "store/weather"

import { DATE_FORMAT } from "modules/datepicker/constants"
import { useTranslation } from "react-i18next"
import { isFeatureEnabled } from "config/features"

function Dashboard() {
  useTitle("Dashboard")
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const { guide } = useSelector((state) => state.user)
  const [params, updateSearchFilters] = useSearchFilter({
    accessAttributes: ["range", "date", "weather", "trip_id", "journal_date", "unavailable_id"]
  })
  const [paramsState, setParamsState] = useState(params)

  const iframeUrl =
    isFeatureEnabled('AI_DASHBOARD') && process.env.REACT_APP_AI_DASHBOARD_URL && guide?.id
      ? `${process.env.REACT_APP_AI_DASHBOARD_URL}?guide_id=${guide.id}`
      : ""

  const dates = useMemo(() => {
    if (!params.date || !params.range) return {}
    const range = params.range === "week" ? "weekDay" : params.range
    const date = global.dateTime(params.date)
    const dates = {}

    if (params.range === "month") {
      dates.start = date.clone.startOf(range).startOf("weekDay", 1).format()
      dates.end = date.clone.endOf(range).endOf("weekDay", 1).format()
    } else {
      dates.start = date.clone.startOf(range, 1).format()
      dates.end = date.clone.endOf(range, 1).format()
    }

    return dates
  }, [params.date, params.range])

  const changeHandler = useCallback(
    ({ target }) =>
      setParamsState((prevParamsState) => ({
        ...prevParamsState,
        [target.name]: target.value
      })),
    []
  )

  useEffect(() => {
    if (isEqual(paramsState, omit(params, ["journal_date", "unavailable_id"]))) return
    updateSearchFilters(paramsState)
  }, [paramsState]) //eslint-disable-line

  useEffect(() => {
    if (!dates.start || !dates.end) return
    const data = {}

    data.include_stats = true
    data["q[date_gteq]"] = dates.start
    data["q[date_lteq]"] = dates.end

    dispatch(getDashboardData(data))
  }, [dates.start, dates.end]) //eslint-disable-line

  useEffect(() => {
    if (!dates.start || !dates.end || !params.weather) return
    const data = {}
    const startMoment = moment(dates.start)
    const endMoment = moment(dates.end)

    if (params.trip_id) data.trip_id = params.trip_id

    data.forecast_date = []
    while (startMoment.isSameOrBefore(endMoment)) {
      data.forecast_date.push(startMoment.format(DATE_FORMAT))
      startMoment.add(1, "day")
    }

    dispatch(guideForecast(data))
  }, [dates.start, dates.end, params.trip_id, params.weather]) // eslint-disable-line

  return (
    <div className="hstack flex-fill z-0" id="dashboard">
      {/* <Sidebar
        className="border-top border-start border-bottom border-gray-lightest rounded-start bg-white p-15 align-self-stretch d-none d-md-block"
        params={params}
        onChangeFilters={changeHandler}
      />
      <div className="vstack w-100 overflow-x-auto">
        <Header
          className="border border-gray-lightest rounded-top rounded-start-0 bg-white z-1 flex-wrap"
          params={params}
          onChangeFilters={changeHandler}
        />
        <Calendar className="border-start border-end border-bottom border-gray-lightest rounded-bottom rounded-start-0 bg-white overflow-auto z-0 flex-fill" />
      </div>
      <DefaultErrorBoundary>
        <Outlet />
      </DefaultErrorBoundary> */}
      {/* <iframe title="AI Dashboard" src={`${process.env.REACT_APP_AI_DASHBOARD_URL}?guide_id=${guide?.id}`} className="w-full h-full" /> */}
   
      {iframeUrl ? (
        <iframe
          title="AI Dashboard"
          src={iframeUrl}
          className="w-full h-full"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <Result
            status="info"
            title= {t("dashboard.dashboard_not_configured_yet")}
            subTitle={t("dashboard.subTitle")}
          />
        </div>
      )}
    </div>
  
  )

}

export default Dashboard
